import { t } from 'i18next';

import MarkdownContainer from '../MarkdownContainer/MarkdownContainer';

import styles from './ProgressGauge.module.css';

/**
 * Clamp a fill rate to 0–100 for the CSS bar.
 * @param {number} percent - Fill rate
 * @returns {number} Clamped percent
 */
function clampPercent(percent) {
  if (!Number.isFinite(percent)) return 0;
  return Math.min(100, Math.max(0, percent));
}

/**
 * Fill gauges for dashboard (CSS, not Recharts).
 * @param {object} props
 * @param {ApiChartGauge[]} props.gauges - Gauges to render
 * @returns {JSX.Element}
 */
function ProgressGauge({ gauges }) {
  if (!gauges?.length) {
    return <p className={styles['progress-gauge-empty']}>{t('dashboard.emptyChart')}</p>;
  }

  return (
    <div className={styles['progress-gauge']}>
      {gauges.map((gauge) => {
        const fill = clampPercent(gauge.percent);
        return (
          <div key={`${gauge.label}-${gauge.config ?? ''}`} className={styles['progress-gauge-item']}>
            <div className={styles['progress-gauge-header']}>
              <span className={styles['progress-gauge-label']}>{gauge.label}</span>
              {gauge.config ? (
                <span className={styles['progress-gauge-config']}>{gauge.config}</span>
              ) : null}
            </div>
            <div className={styles['progress-gauge-bar']}>
              <div className={styles['progress-gauge-track']}>
                <div
                  className={styles['progress-gauge-fill']}
                  style={{ width: `${fill}%` }}
                />
              </div>
              <span className={styles['progress-gauge-percent']}>
                {`${fill} %`}
              </span>
            </div>
            <dl className={styles['progress-gauge-stats']}>
              <div className={styles['progress-gauge-stat']}>
                <dt>{t('dashboard.capacity')}</dt>
                <dd>{gauge.capacity}</dd>
              </div>
              <div className={styles['progress-gauge-stat']}>
                <dt>{t('dashboard.total')}</dt>
                <dd>{gauge.total}</dd>
              </div>
              <div className={styles['progress-gauge-stat']}>
                <dt>{t('dashboard.remaining')}</dt>
                <dd>{gauge.remaining}</dd>
              </div>
            </dl>
            {gauge.description ? (
              <MarkdownContainer
                content={gauge.description}
                className={styles['progress-gauge-description']}
              />
            ) : null}
          </div>
        );
      })}
    </div>
  );
}

export default ProgressGauge;
